import React, { useState, useEffect } from 'react';
import { T } from 'react-translator-component';
import './InactivityWarning.css';

/**
 * Componente InactivityWarning
 * Muestra un modal de confirmación cuando el usuario ha estado inactivo
 * Pregunta al usuario si sigue ahí, si no responde en 30 segundos, se deslogueará
 */
const InactivityWarning = ({ isActive, onDismiss, onLogout, countdownSeconds }) => {
  const [countdown, setCountdown] = useState(countdownSeconds || 30);

  useEffect(() => {
    if (!isActive) {
      setCountdown(countdownSeconds);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onLogout();
          return countdownSeconds;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isActive, countdownSeconds, onLogout]);

  if (!isActive) return null;

  return (
    <div className="inactivity-warning-overlay">
      <div className="inactivity-warning-modal">
        <div className="inactivity-warning-icon">
          <i className="fas fa-hourglass-half"></i>
        </div>
        
        <h2 className="inactivity-warning-title">
          {T('kiosk.inactivity-warning-title')}
        </h2>
        
        <p className="inactivity-warning-message">
          {T('kiosk.inactivity-warning-message')}
        </p>
        
        <div className="inactivity-warning-countdown">
          <p className="countdown-text">
            {T('kiosk.inactivity-countdown')}: <span className="countdown-number">{countdown}s</span>
          </p>
          <div className="countdown-bar">
            <div 
              className="countdown-bar-fill" 
              style={{ width: `${(countdown / countdownSeconds) * 100}%` }}
            ></div>
          </div>
        </div>

        <div className="inactivity-warning-buttons">
        <button 
            className="btn-inactivity-logout"
            onClick={onLogout}
          >
            {T('kiosk.inactivity-logout')}
          </button>
          <button 
            className="btn-inactivity-dismiss"
            onClick={onDismiss}
          >
            {T('kiosk.inactivity-stay')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;


